let listeners = [];
let lastToast = null;
const DEBOUNCE_MS = 300; // Prevent duplicate toasts within 300ms

const emit = (toast) => {
  // Debounce duplicate toasts
  if (lastToast && 
      lastToast.type === toast.type && 
      lastToast.message === toast.message &&
      Date.now() - lastToast.timestamp < DEBOUNCE_MS) {
    return; // Skip duplicate toast
  }
  
  lastToast = { ...toast, timestamp: Date.now() };
  listeners.forEach((l) => l(toast));
};

const toastService = {
  subscribe(listener) {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },

  success(message) {
    if (!message) return;
    emit({ id: Date.now() + Math.random(), type: 'success', message });
  },

  error(message) {
    if (!message) return;
    console.log('🔥 ERROR TOAST FIRED:', message); // Debug logging
    emit({ id: Date.now() + Math.random(), type: 'error', message });
  },

  info(message) {
    if (!message) return;
    emit({ id: Date.now() + Math.random(), type: 'info', message });
  },

  warning(message) {
    if (!message) return;
    emit({ id: Date.now() + Math.random(), type: 'warning', message });
  }
};

export default toastService;
